import React, {useState} from "react";
import CreateSkill from "../components/CreateSkill";
import {ListBlock} from "./ListBlock";
import {SideItemRow} from "./SideItemRow";

export const SkillsBlock = ({project, onUpdateProject, getUserProjects}) => {
    const [openModal, setOpenModal] = useState(false);
    const [selectedSkill, setSelectedSkill] = useState(null);
    const [search, setSearch] = useState("");

    const onUpdateSkill = async (skill) => {
        const newProject = {...project};
        if (!newProject.skills) newProject.skills = [];
        const index = newProject.skills.findIndex((s) => s.id === skill.id);
        if (index >= 0) {
            newProject.skills[index] = skill;
        } else {
            newProject.skills.push(skill);
        }
        await onUpdateProject(newProject);
        await getUserProjects();
    };

    const onRemove = async (id) => {
        const newProject = {...project};
        newProject.skills = newProject?.skills?.filter((item) => item.id !== id) || [];
        await onUpdateProject(newProject);
        await getUserProjects();
    };

    const items = project?.skills?.filter(
        (item) => item?.name?.toLowerCase()?.includes(search?.toLowerCase()),
    ) || [];

    return (
        <>
            <CreateSkill
                open={openModal}
                project={project}
                skill={selectedSkill}
                handleClose={() => {
                    setOpenModal(false);
                    setSelectedSkill(null);
                }}
                handleSubmit={onUpdateSkill}
                onRemove={onRemove}
            />
            <ListBlock
                title="Skills"
                items={items}
                search={search}
                onChangeSearch={setSearch}
                onCreate={() => setOpenModal(true)}
                mapItem={(skill) => (
                    <SideItemRow
                        key={skill?.id}
                        label={skill?.name}
                        tooltip={skill?.name}
                        onClick={() => {
                            setSelectedSkill(skill);
                            setOpenModal(true);
                        }}
                    />
                )}
            />
        </>
    );
};
